export default {
  list() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/staffs?list`);
  },
  indexBySettlementId(id) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/staffs/settlements/${ id }`);
  },
  async pit4YearSummary({ period }) {
    return await axios.post(`${ import.meta.env.VITE_SITE_URL }/staffs/declarations/pit4-year-summary`, {
      period,
    });
  },
  countOfEmployees() {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/staffs/get-count`);
  },
  listWithAgreementsForZus({
                             year,
                             month,
                           }) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/staffs/agreements/for-zus', {
      year,
      month,
    });
  },
  getAgreementAnnexes(id) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/staffs/agreements/annexes/${ id }`);
  },
  getRates(year, month) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/staffs/get/rates`, {
      year,
      month
    });
  },
};
